/**
 * Compliance Service
 * Manages compliance acceptance tracking (once per day)
 */

const COMPLIANCE_KEY = "odin-compliance-accepted";

/**
 * Get the current date string (YYYY-MM-DD)
 * @returns {string}
 */
const getCurrentDateString = () => {
  const now = new Date();
  return now.toISOString().split("T")[0]; // Format: YYYY-MM-DD
};

/**
 * Check if compliance was already accepted today
 * @returns {boolean}
 */
export const isComplianceAcceptedToday = () => {
  try {
    const stored = localStorage.getItem(COMPLIANCE_KEY);
    if (!stored) return false;

    const acceptedDate = JSON.parse(stored).date;
    const today = getCurrentDateString();

    return acceptedDate === today;
  } catch (error) {
    console.error("[ComplianceService] Error checking compliance:", error);
    return false;
  }
};

/**
 * Mark compliance as accepted for today
 */
export const markComplianceAccepted = () => {
  try {
    const data = {
      date: getCurrentDateString(),
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem(COMPLIANCE_KEY, JSON.stringify(data));
    console.log("[ComplianceService] Compliance accepted for", data.date);
  } catch (error) {
    console.error("[ComplianceService] Error saving compliance:", error);
  }
};

/**
 * Clear compliance acceptance (for testing purposes)
 */
export const clearComplianceAcceptance = () => {
  try {
    localStorage.removeItem(COMPLIANCE_KEY);
    console.log("[ComplianceService] Compliance acceptance cleared");
  } catch (error) {
    console.error("[ComplianceService] Error clearing compliance:", error);
  }
};

/**
 * Get compliance acceptance info
 * @returns {Object|null}
 */
export const getComplianceInfo = () => {
  try {
    const stored = localStorage.getItem(COMPLIANCE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error("[ComplianceService] Error getting compliance info:", error);
    return null;
  }
};
